import React from 'react';
import QualityApprovalAddEditModal from './qualityapproval-add-edit';

import { MODAL_TYPES } from 'Feature/components/app-modals';
import { selectedPart } from './store/selectors';
import { useSelector } from 'react-redux';

const { QUALITYAPPROVAL_ADD_EDIT } = MODAL_TYPES;

const QualityApprovalModals = () => {
  const currentSelectedPart = useSelector(selectedPart);
  return (
    <>
      <QualityApprovalAddEditModal
        selectedPart={currentSelectedPart}
        modalId={QUALITYAPPROVAL_ADD_EDIT}
      />
    </>
  );
};

export default QualityApprovalModals;
